const FRIDAYAGENT_EVENTS = {
  事件ID: {
    code: '事件ID',
    name: '事件名称'
  },
  WEB_TEAMS_CLICK_LOGIN_TOGGLE_TYPE: {
    code: 'web_teams_click_login_toggle_type',
    name: '点击切换登录方式'
  },
  WEB_TAMES_CLICK_NAV_CONTACT_ADMIN: {
    code: 'web_tames_click_nav_contact_admin',
    name: '点击联系管理员'
  },
  WEB_TAMES_CLICK_NAV_HELP: {
    code: 'web_tames_click_nav_help',
    name: '点击帮助'
  },
  WEB_TAMES_CLICK_NAV_FEEDBACK: {
    code: 'web_tames_click_nav_feedback',
    name: '点击反馈'
  },
  WEB_TAMES_CLICK_NAV_SWITCH: {
    code: 'web_tames_click_nav_switch',
    name: '切换企业'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_DATE_PICKER: {
    code: 'web_teams_click_appointment_date_picker',
    name: '筛选预约日期'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_ROOM_PICKER: {
    code: 'web_teams_click_appointment_room_picker',
    name: '筛选会议室列表'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_TURN_PAGE: {
    code: 'web_teams_click_appointment_turn_page',
    name: '点击会议室列表翻页'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_SEARCH_ROOM: {
    code: 'web_teams_click_appointment_search_room',
    name: '点击搜索会议室'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_MODIFY_DATE: {
    code: 'web_teams_click_appointment_modify_date',
    name: '点击修改会议的预约日期'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_MODIFY_TIME: {
    code: 'web_teams_click_appointment_modify_time',
    name: '点击修改会议的预约时间'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_MODIFY_ROOM: {
    code: 'web_teams_click_appointment_modify_room',
    name: '点击修改会议的预约地点'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_ADD_MEMBER: {
    code: 'web_teams_click_appointment_add_member',
    name: '点击预约弹窗添加参会人'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_MORE: {
    code: 'web_teams_click_appointment_more',
    name: '点击更多'
  },
  WEB_TEAMS_CLICK_APPOINTMENT_UPLOAD_FILE: {
    code: 'web_teams_click_appointment_upload_file',
    name: '点击预约弹窗添加文件'
  },
  WEB_TEAMS_CLICK_CONTACT_SEARCH: {
    code: 'web_teams_click_contact_search',
    name: '搜索联系人'
  },
  WEB_TEAMS_CLICK_CONTACT_DETAIL: {
    code: 'web_teams_click_contact_detail',
    name: '点击查看联系人详情'
  },
  WEB_TEAMS_CLICK_DETAIL_SHARE: {
    code: 'web_teams_click_detail_share',
    name: '点击分享会议'
  },
  WEB_TEAMS_CLICK_DETAIL_COPY: {
    code: 'web_teams_click_detail_copy',
    name: '点击复制分享信息'
  },
  WEB_TEAMS_CLICK_DETAIL_SIGN: {
    code: 'web_teams_click_detail_sign',
    name: '点击会议室签到'
  },
  WEB_TEAMS_CLICK_DETAIL_MODIFY_INFO: {
    code: 'web_teams_click_detail_modify_info',
    name: '点击修改会议信息'
  },
  WEB_TEAMS_CLICK_DETAIL_ADD_MEMBER: {
    code: 'web_teams_click_detail_add_member',
    name: '点击会议详细添加参会人'
  },
  WEB_TEAMS_CLICK_DETAIL_UPLOAD_FILE: {
    code: 'web_teams_click_detail_upload_file',
    name: '点击会议详细添加文件'
  },
  WEB_TEAMS_CLICK_DETAIL_PREVIEW_FILE: {
    code: 'web_teams_click_detail_preview_file',
    name: '点击预览文件'
  },
  WEB_TEAMS_CLICK_DETAIL_DOWNLOAD_FILE: {
    code: 'web_teams_click_detail_download_file',
    name: '点击下载文件'
  },
  WEB_TEAMS_CLICK_DETAIL_END_MEETING: {
    code: 'web_teams_click_detail_end_meeting',
    name: '点击提前结束会议'
  },
  WEB_TEAMS_CLICK_DETAIL_CANCEL_MEETING: {
    code: 'web_teams_click_detail_cancel_meeting',
    name: '点击取消会议'
  },
  WEB_TEAMS_CLICK_DETAIL_CHANGE_ATTEND: {
    code: 'web_teams_click_detail_change_attend',
    name: '点击修改参会状态'
  },
  WEB_TEAMS_CLICK_DETAIL_WRITE_SUMMARY: {
    code: 'web_teams_click_detail_write_summary',
    name: '点击写纪要'
  },
  WEB_TEAMS_CLICK_DETAIL_READ_SUMMARY: {
    code: 'web_teams_click_detail_read_summary',
    name: '点击查看纪要'
  },
  WEB_TEAMS_CLICK_DETAIL_KNOW_CANCEL: {
    code: 'web_teams_click_detail_know_cancel',
    name: '点击知晓会议取消'
  },
  WEB_TEAMS_CLICK_DETAIL_KNOW_CHANGE: {
    code: 'web_teams_click_detail_know_change',
    name: '点击知晓会议变更'
  },
  WEB_TEAMS_CLICK_ADD_MEMBER_CHECKED: {
    code: 'web_teams_click_add_member_checked',
    name: '选择参会人'
  },
  WEB_TEAMS_PAGEVIEW_APPOINTMENT: {
    code: 'web_teams_pageview_appointment',
    name: '会议预约页曝光'
  },
  WEB_TEAMS_PAGEVIEW_SCHEDULE: {
    code: 'web_teams_pageview_schedule',
    name: '会议安排页曝光'
  },
  WEB_TEAMS_PAGEVIEW_CONTACT: {
    code: 'web_teams_pageview_contact',
    name: '通讯录曝光'
  },
  WEB_TEAMS_PAGEVIEW_ROOM_DETAIL: {
    code: 'web_teams_pageview_room_detail',
    name: '会议室详细页曝光'
  },
  WEB_TEAMS_PAGEVIEW_MEETING_DETAIL: {
    code: 'web_teams_pageview_meeting_detail',
    name: '会议详细页曝光'
  },
  WEB_TEAMS_PAGEVIEW_MEETING_INVITE: {
    code: 'web_teams_pageview_meeting_invite',
    name: '会议邀请页曝光'
  },
  WEB_TEAMS_TIMEONPAGE_APPOINTMENT: {
    code: 'web_teams_timeonpage_appointment',
    name: '会议预约页停留'
  },
  WEB_TEAMS_TIMEONPAGE_SCHEDULE: {
    code: 'web_teams_timeonpage_schedule',
    name: '会议安排页停留'
  },
  WEB_TEAMS_TIMEONPAGE_CONTACT: {
    code: 'web_teams_timeonpage_contact',
    name: '通讯录停留'
  },
  WEB_TEAMS_TIMEONPAGE_ROOM_DETAIL: {
    code: 'web_teams_timeonpage_room_detail',
    name: '会议室详细页停留'
  },
  WEB_TEAMS_TIMEONPAGE_MEETING_DETAIL: {
    code: 'web_teams_timeonpage_meeting_detail',
    name: '会议详细页停留'
  },
  WEB_TEAMS_TIMEONPAGE_MEETING_INVITE: {
    code: 'web_teams_timeonpage_meeting_invite',
    name: '会议邀请页停留'
  }
};

export default FRIDAYAGENT_EVENTS;
